// Toaster Notification Constants
export const TOP_RIGHT = "top-right";
export const BOTTOM_RIGHT = "bottom-right";
export const ERROR = "Error";
export const SUCCESS = "Success";
export const WARNING = "Warning";
export const REFUND_DESCRIPTION = `refundable $TYPE of $AMOUNT - returnable to the CLIENT up to $TIME after the event has been held, once property has been inspected for any possible damage from special event.`;

// Client Type category names (Client Type is API-driven via getClientTypes()/
// ClientTypeServices - this is NOT the full list of categories, just the
// subset of Client Type names that trigger "collaborator"/School Name
// collection in contract forms, e.g. a college whose booking is on behalf of
// a school. Keep this in sync if that business rule's category set changes;
// do not use it as a stand-in for the live Client Type dropdown options.
export const COLLABORATOR_CLIENT_TYPES = ["COLLEGE"];

export const isCollaboratorClientType = (name) =>
  COLLABORATOR_CLIENT_TYPES.includes(name);
